import { ApolloProvider, ApolloClient } from '@apollo/client';
import routes from './routes';
import * as React from 'react';
import { Provider, Store } from 'react-redux';
import { IntlProvider } from 'react-intl';
// @ts-expect-error
import { CookiesProvider } from 'react-cookie';
import { Router, browserHistory } from 'react-router';
import { UserAgentProvider, windowStr } from 'lib/currentUserAgent';

import '../../src/styles/app.scss';

const Root = <T1, T2>(props: { apolloClient: ApolloClient<T1>; reduxStore: Store<T2> }) => {
  const { apolloClient, reduxStore } = props;
  return (
    <IntlProvider locale="en">
      <Provider store={reduxStore}>
        {/* @ts-expect-error */}
        <ApolloProvider store={reduxStore} client={apolloClient}>
          <UserAgentProvider userAgentSpec={windowStr}>
            <CookiesProvider>
              <Router history={browserHistory}>{routes}</Router>
            </CookiesProvider>
          </UserAgentProvider>
        </ApolloProvider>
      </Provider>
    </IntlProvider>
  );
};

export default Root;
